<template lang="pug">
  .maptalks-three-layer
    slot(v-if='ready')
</template>

<script>
import * as THREE from 'three'
import { createThreeLayer } from '@/utils/map'

export default {
  name: 'maptalks-three-layer',
  props: {
    name: {
      type: String,
      default: `three-layer-${Date.now()}`
    }
  },
  data () {
    return {
      mapObject: null,
      ready: false
    }
  },
  mounted () {
    const map = this.$parent.mapObject

    const threeLayer = createThreeLayer({ name: this.name })

    threeLayer.prepareToDraw = (gl, scene, camera) => {
      const light = new THREE.SpotLight(0xffffff)
      light.position.copy(camera.position)
      scene.add(light)
      scene.add(new THREE.AmbientLight(0xffffff))
      threeLayer.redraw()
    }

    threeLayer.onCanvasCreate = () => {
      this.ready = true
    }

    threeLayer.addTo(map)

    this.mapObject = threeLayer
  },
  beforeDestroy () {
    this.mapObject.remove()
  }
}
</script>

<style scoped>
.maptalks-three-layer {
  display: none;
}
</style>
